/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * @description Fonts css style properties
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.10.0
 * @since 1.0.0
 */

import { linkDefaultColor, linkDefaultColorHover } from './colors/link';
import { textColor } from './colors/palette';
import { fontSizeBase, fontSizeSmall } from './global';

export const textHeader2 = [
    { fontFamily: 'DefaultMedium' },
    { fontSize: '32px' },
    { fontWeight: 600 },
    { lineHeight: '1.25' },
    { letterSpacing: '0.5px' },
    { color: textColor },
    { marginBottom: '24px' },
];

export const textHeader3 = [
    { fontFamily: 'DefaultMedium' },
    { fontSize: '20px' },
    { fontWeight: 500 },
    { lineHeight: '28px' },
    { letterSpacing: '0.5px' },
    { color: textColor },
    { marginBottom: '20px' },
];

export const textHeader5 = [
    { fontFamily: 'DefaultMedium' },
    { fontSize: '15px' },
    { fontWeight: 500 },
    { lineHeight: '24px' },
    { color: textColor },
];

export const textMain = [
    { fontFamily: 'DefaultRegular' },
    { fontSize: fontSizeBase },
    { fontWeight: 400 },
    { lineHeight: '1.6' },
    { letterSpacing: 'normal' },
    { color: textColor },
];

export const textMainBold = [
    { fontFamily: 'DefaultMedium' },
    { fontSize: fontSizeBase },
    { fontWeight: 500 },
    { lineHeight: '1.6' },
    { letterSpacing: 'normal' },
    { color: textColor },
];

export const textSmall = [
    { fontFamily: 'DefaultRegular' },
    { fontSize: fontSizeSmall },
    { fontWeight: 400 },
    { lineHeight: '1.33' },
    { letterSpacing: 'normal' },
    { color: textColor },
];

export const textSmallBold = [
    { fontFamily: 'DefaultMedium' },
    { fontSize: fontSizeSmall },
    { fontWeight: 500 },
    { lineHeight: '1.33' },
    { letterSpacing: '0.3px' },
    { color: textColor },
];

export const textLink = [
    { fontFamily: 'DefaultRegular' },
    { color: linkDefaultColor },
    { '&:hover': {
        color: linkDefaultColorHover,
    } },
];
